export default class Body {
	constructor() {
		this.lastScroll = 0;
		this.scrollingEvent = null;
		this.scrollUp = 'scroll-up';
		this.scrollDown = 'scroll-down';
		this.scrollThreshold = 3;
	}

	init() {
		this.scrollingEvent = this.toggleScrollingClass.bind(this);
		window.addEventListener('scroll', this.scrollingEvent, false);
		this.toggleScrollingClass();
	}

	toggleScrollingClass() {
		const currentScroll = window.scrollY;

		if (currentScroll <= this.scrollThreshold) {
			document.body.classList.remove(this.scrollUp, this.scrollDown);
			return;
		}

		if (currentScroll > this.lastScroll) {
			document.body.classList.remove(this.scrollUp);
			document.body.classList.add(this.scrollDown);
		} else if (currentScroll < this.lastScroll) {
			document.body.classList.add(this.scrollUp);
		}

		this.lastScroll = currentScroll;
	}

	destroy() {
		window.removeEventListener('scroll', this.scrollingEvent, false);
	}
}
